"use client";

import { motion } from 'framer-motion';
import { useComponentTranslations } from './LanguageProvider';
import { FC } from 'react';

type IndustrialsFormProps = {
  label: string;
  subtitle?: string;
};
export const IndustrialsForm: FC<IndustrialsFormProps> = ({ label, subtitle }) => {
  const { t } = useComponentTranslations('Agriculture');

  return (
    <section className="my-24">
      <div className="max-w-3xl neu-raised rounded-2xl p-8 mx-auto">
        <h2 className="text-3xl text-center font-bold mb-4">{label}</h2>
        {subtitle && (
          <p className="text-white/70 text-sm mb-4">{subtitle}</p>
        )}
        <form className="w-full">
          <div className="mb-4">
            <label className="block text-xs text-white/70">{t('email')}</label>
            <input type="email" placeholder="your@email.com" className="mt-1 w-full rounded-lg bg-white/10 border border-white/10 px-3 py-2 text-xs text-white placeholder:text-white/50 outline-none" />
          </div>
          <div className="mb-4">
            <label className="block text-xs text-white/70">{t('name')}</label>
            <input type="text" placeholder={t('name')} className="mt-1 w-full rounded-lg bg-white/10 border border-white/10 px-3 py-2 text-xs text-white placeholder:text-white/50 outline-none" />
          </div>
          <div className="mb-4">
            <label className="block text-xs text-white/70">{t('yourMessage')}</label>
            <textarea placeholder={t('yourMessage')} className="mt-1 w-full rounded-lg bg-white/10 border border-white/10 px-3 py-2 text-xs text-white placeholder:text-white/50 outline-none resize-none" rows={4}></textarea>
          </div>
          <motion.button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {t('submit')}
          </motion.button>
        </form>
      </div>
    </section>
  )
}